module.exports = __webpack_public_path__ + "img/partnerzy-05_ongeo_services.a8ada107.svg";